import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkbox", "circle", "question", "row"];

  check() {
    if (this.checkboxTarget.checked) {
      this.questionTarget.classList.remove("font-inactive");
      this.rowTarget.classList.add("active");
      this.rowTarget.classList.remove("inactive");
    } else {
      this.rowTarget.classList.add("inactive");
      this.questionTarget.classList.add("font-inactive");
    }
  }
}
